import styled from "styled-components";

export const CustomPaginationContainer = styled.div`
  .pagination-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    @media (max-width: 575.98px) {
      flex-direction: column;
    }
  }
  .page-options-container {
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 575.98px) {
      margin-bottom: 5px;
    }
  }

  button {
    min-width: 23px !important;
    height: 23px;
  }

  .MuiPaginationItem-root {
    font-family: "Plus Jakarta Sans", sans-serif;
  }
`;
